import { AGENT_FORM, AGENT_SEED } from '../agents/agentLook';
import { DotOrb } from '../agents/orb/DotOrb';

type AdvisorId = keyof typeof AGENT_FORM;

/**
 * The asesor who wrote a report, drawn as the Dale Agents draw them: the same
 * orange dot in a small dark tile, each person in their own form, so a report
 * and the Agents room read as one team.
 */
export function AdvisorOrb({ personaId, size }: { personaId: string; size: number }) {
  const id: AdvisorId = isAdvisorId(personaId) ? personaId : 'direccion';
  return (
    <span className="agents-tile intel-orb" style={{ width: size, height: size }} aria-hidden="true">
      <DotOrb size={size} form={AGENT_FORM[id]} seed={AGENT_SEED[id]} onDark />
    </span>
  );
}

function isAdvisorId(value: string): value is AdvisorId {
  return Object.prototype.hasOwnProperty.call(AGENT_FORM, value);
}
